import { render, staticRenderFns } from "./second-index.vue?vue&type=template&id=249c99a8&scoped=true"
import script from "./second-index.vue?vue&type=script&lang=js"
export * from "./second-index.vue?vue&type=script&lang=js"
import style0 from "./second-index.vue?vue&type=style&index=0&id=249c99a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249c99a8",
  null
  
)

export default component.exports